<script>
import pagination from "@/mixins/pagination";
import tableSearch from "@/mixins/tableSearch";
import CommonTableComponent from "@/components/table.vue";
import apiEndpoints from "@/services/apiEndpoints";

export default {
  name: 'SearchDataWasteModal',
  components: {
    CommonTableComponent
  },
  mixins: [pagination, tableSearch],
  props: ['dataSearch', 'disabledSearch'],
  data() {
    return {
      currentInputSelectData: "",
      header: this.$constant.tableHeaders.common.searchs.waste,
      busyGetData: false,
      data: [],
      visible: false,
      filters: {
        searchValue: "",
        column: "wastes.waste_cd",
        dir: "DESC",
        page: 1
      }
    };
  },
  methods: {
    async getData() {
      this.busyGetData = true;
      const response = await this.$http.get(apiEndpoints.popup_search_wastes, {
        ...this.filters,
      });
      const { status, data } = response;
      this.busyGetData = false;
      if (status) {
        const result = data.result;
        this.data = this.$_.isEmpty(result) ? [] : result;
        // const meta = this.$_.isEmpty(result.meta) ? [] : result.meta;
        // this.setMeta(meta);
      }
    },
    updateValue: function(value) {
      this.dataSearch.waste = value;
      this.$emit('dataSelected', this.dataSearch)
      this.closeModal();
    },
    openModal() {
      this.$bvModal.show("modal-select-data-waste");
    },
    closeModal() {
      this.$bvModal.hide("modal-select-data-waste");
    },
    performDebounceSearch () {
      this.resetToFirstPage();
      this.updateUrlFilters();
    },
    updateUrlFilters () {
      this.getData()
    },
  },
  watch: {
    "filters.page": {
      immediate: false,
      handler() {
        this.updateUrlFilters();
      }
    },
  },
  computed: {
    headers() {
      return this.header;
    },
    inputSearch: {
      get() {
        return this.dataSearch.waste;
      },
      set(newValue) {
        return this.dataSearch.waste = newValue;
      }
    },
  }
};
</script>
<template>
  <div class="mb-2 d-xl-flex">
    <slot name="label">
      <label :for="'project'" class="col-form-label text-nowrap me-2"
        >廃棄物</label
      >
    </slot>
    <div class="d-flex w-100">
      <input
        :disabled="disabledSearch"
        type="text"
        class="form-control me-2"
        id="project"
        v-model="inputSearch"
      />
      <b-button :disabled="disabledSearch" @click="openModal()" variant="outline-info"
        ><i class="bx bx-file-find"></i
      ></b-button>
    </div>
    <!-- modal area -->
    <b-modal
      size="xl"
      id="modal-select-data-waste"
      centered
      title-class="font-18"
      hide-footer
      title="廃棄物一覧"
      scrollable
      @show="getData"
    >
      <b-row>
        <div>
          <b-form-input
            placeholder="フィルター..."
            v-model="filters.searchValue"
            v-on:keyup.enter="performDebounceSearch"
            type="text"
            id="name"
          ></b-form-input>
        </div>
      </b-row>
      <b-row class="mt-2">
        <b-overlay
          :show="busyGetData"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <CommonTableComponent :height-class="`table-wrapper-500`">
            <thead class="table-light">
              <tr>
                <th
                  v-for="(item, index) in headers"
                  :key="index"
                  :class="getHeaderClass(item)"
                >
                  <span v-if="item.sortable" @click="clickSort(item.value)">
                    {{ item.text }}
                    <i :class="getSortClass(item.value)"></i>
                  </span>
                  <span v-else>
                    {{ item.text }}
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in data"
                :key="index"
                class="cursor-pointer"
                @click="updateValue(item.name)"
              >
                <td>{{ item.waste_cd }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.case_name }}</td>
                <td>{{ item.waste_category_name }}</td>
              </tr>
              <tr v-if="!data.length && !busyGetData">
                <td :colspan="headers.length" class="text-center">
                  データなし。
                </td>
              </tr>
            </tbody>
          </CommonTableComponent>
        </b-overlay>
      </b-row>
    </b-modal>
  </div>
</template>
